import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import DownloadFormA from "../FormA/DownloadFormA.component";
import { contractorFormAFields, initialContractorFormA } from "./Constant";
import { getContractorPersonById } from "app/_services/UserManagement/ContractorPersonService";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";

function DownloadContractorFormA() {
  const { id } = useParams();

  const [data, setData] = useState({
    ...initialContractorFormA,
  });

  useEffect(() => {
    if (!id) return;

    getContractorPersonById(id).then((response) => {
      if (!response?.data) return;
      const contractorData = response.data || {};

      setData((prev) => ({
        ...prev,
        ...contractorData,
        startDateAtMines: contractorData.startDateAtMines?.slice(0, 10) || "",
        dateOfJoining: contractorData.dateOfJoining?.slice(0, 10) || "",
        dateOfSeparation: contractorData.dateOfSeparation?.slice(0, 10) || "",
        siteType: contractorData?.ehsSite?.siteType || "",
        mineName: contractorData?.ehsSite?.name || "",
        mineCode: contractorData?.ehsSite?.siteId || "",
        fullName: `${contractorData.firstName || ""} ${contractorData.lastName || ""}`,
        ...(contractorData.contractorFormA || {}),
        contractorName: contractorData.contractors?.contractorLegalEntity || "",
        contractorCode:
          contractorData.contractors?.contractorCode +
            " / " +
            contractorData.contractors?.contractorEntityCode || "",
        profilePicture: contractorData.contractorFormA?.profilePicture
          ? `${URL_CONFIG.IMG_URL}${contractorData.contractorFormA?.profilePicture}`
          : "",
        fitnessCertificatePmeDate:
          (contractorData?.fitnessCertificatePmeDate &&
            DDMMYYYYFormat(contractorData?.fitnessCertificatePmeDate)) ||
          (contractorData?.lastPMEDate && DDMMYYYYFormat(contractorData?.lastPMEDate)) ||
          "NA",
        fitnessCertificatePmeNumber:
          contractorData?.fitnessCertificatePmeNumber ||
          contractorData?.pmeCertificateNo ||
          "NA",
        refresherCertificateDate:
          (contractorData?.refresherCertificateDate &&
            DDMMYYYYFormat(contractorData?.refresherCertificateDate)) ||
          "NA",
        refresherCertificateNumber: contractorData?.refresherCertificateNumber || "NA",
        initialTrainingCertificateDate:
          (contractorData?.initialTrainingCertificateDate &&
            DDMMYYYYFormat(contractorData?.initialTrainingCertificateDate)) ||
          "NA",
        initialTrainingCertificateNumber:
          contractorData?.initialTrainingCertificateNumber || "NA",
        dob: (contractorData?.dob && DDMMYYYYFormat(contractorData?.dob)) || "",
        dateOfJoining:
          (contractorData?.dateOfJoining &&
            DDMMYYYYFormat(contractorData?.dateOfJoining)) ||
          "",
        startDateAtMines:
          (contractorData?.startDateAtMines &&
            DDMMYYYYFormat(contractorData?.startDateAtMines)) ||
          "",
        fitnessCertificateImeDate: contractorData?.fitnessCertificateImeDate || "NA",
        fitnessCertificateImeNumber: contractorData?.fitnessCertificateImeNumber || "NA",
      }));
    });
  }, [id]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "User Management", path: "#" },
          { name: "Contractor", path: "/user-management/contractor-person" },
          { name: "Download Form A", path: "#" },
        ]}
      />
      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title mb-0">
            <h3 class="text-capitalize mb-1">Download Contractor Form A</h3>
          </Card.Title>
          <DownloadFormA fieldsObj={contractorFormAFields} data={data} />
        </Card.Body>
      </Card>
    </div>
  );
}

export default DownloadContractorFormA;
